import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Selectsearch from "react-select"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";

import {
	FormGroup,
	Label,
	Input,
} from 'reactstrap';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import {   
    fetchInjuryChart,
    editInjuryChart,
    allSSTeam
 } from 'Actions';



class EditElements extends React.Component {
   
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    static num1 = 0;

    UNSAFE_componentWillMount() {
        this.props.allSSTeam();
	}
   constructor(props) {
      
      super(props);
      this.state = {
            student: '',
            quarter:'',
            seldate:new Date(),            
         };
        
   }
    

    editHandleSubmit(event){
        event.preventDefault();
        this.props.editInjuryChart(event).then((data) => {         
        if(data.status==1){
                setTimeout(this.props.onClick, 6000);
        }
        });
        
    }   
   
  
    handleInput(event) {
        const bullet = "\u2022";
        const inputValue = event.target.value;
        const cursorPosition = event.target.selectionStart;
        let lines = inputValue.split('\n');
      
        for (let i = 0; i < lines.length; i++) {
          const line = lines[i];
          if (!line.trim().startsWith(bullet)) {
            lines[i] = `${bullet} ${line.trimLeft()}`;
          }
        }
      
        let newValue = lines.join('\n');
        if (event.nativeEvent.inputType === 'deleteContentBackward') {
          if (cursorPosition === 0) {
            const lineIndex = newValue.substr(0, cursorPosition).split('\n').length - 1;
            if (lineIndex > 0) {
              const linesArray = newValue.split('\n');
              linesArray.splice(lineIndex, 1);
              newValue = linesArray.join('\n');
            }
          } else if (newValue[cursorPosition - 1] === bullet && (cursorPosition === newValue.length || newValue[cursorPosition] === '\n')) {
            newValue = newValue.slice(0, cursorPosition - 2) + newValue.slice(cursorPosition);
          }
        }
      
        event.target.value = newValue;
      
        this.setState({
          previousLength: newValue.length,
        });
      }
  

   render() {
      
      const { injurychartresponse, ssteamlists, loading} = this.props;
      const studentname=injurychartresponse.student; 
     

      return (
           <div>
               <div className="col-md-12">
                     <form autoComplete="off" id="editassessmentform" onSubmit={(e)=>this.editHandleSubmit(e)}>
                        <div className="row">
                            <div className="col-sm-12 col-md-6">
                            <RctCollapsibleCard heading="Edit Injury Assessment">   
                                        <div className="row float-right"> 
                                        <button type="button" className="mr-3 mb-3 btn btn-outline-warning float-right" onClick={this.props.onClick} >Back</button>
                                        </div>                           
                                    <div className="row">
                                            
                                        <div className="col-sm-12 col-md-8"> 
                                             <h3>Name : {studentname}</h3>   
                                        </div>   
                                        
                                        <div className="col-sm-12 col-md-8">
                                            <h3>Date : {injurychartresponse.cdate}</h3>                                         
                                        </div>  
                                        
                                        <div className="col-sm-12 col-md-6 col-xl-6">   
                                            <FormGroup>
                                                <Label for="Select">Age *</Label>
                                                <input type="text" name="age" id="age" defaultValue={injurychartresponse.sic_age} className="form-control form-control-alternative" required/>
                                            </FormGroup>  
                                        </div> 
                                        <div className="col-sm-12 col-md-6 col-xl-6">   
                                            <FormGroup>
                                                <Label for="Select">Gender *</Label>
                                                    <select name="gender" id="gender" defaultValue={injurychartresponse.sic_gender} className="form-control form-control-alternative" required>
                                                          <option value=""></option>
                                                          <option value="1">Male</option>
                                                          <option value="2">Female</option>                                                          
                                                    </select>
                                            </FormGroup>  
                                        </div>
                                        <div className="col-sm-12 col-md-6 col-xl-6">   
                                            <FormGroup>
                                                <Label for="Select">Assessor Name *</Label>
                                                    <select name="teamid" id="teamid" className="form-control form-control-alternative" required>
                                                          <option value=""></option>
                                                          {ssteamlists.map((teamval) => (   
                                                                injurychartresponse.sic_teamID==teamval.sctID ?                                                       
                                                                <option value={teamval.sctID} selected>{teamval.sc_name}</option>  
                                                                : <option value={teamval.sctID}>{teamval.sc_name}</option>                                                           
                                                            ))}
                                                    </select>
                                            </FormGroup>  
                                        </div>                                         
                                        <div className="col-sm-12 col-md-6 col-xl-6">   
                                            <FormGroup>
                                                <Label for="Select">Skill *</Label>
                                                    <select name="skill" id="skill" defaultValue={injurychartresponse.sic_skill} className="form-control form-control-alternative" required>
                                                          <option value=""></option>
                                                          <option value="Rt Dominant Golfer">Rt Dominant Golfer</option>
                                                          <option value="Lt Dominant Golfer">Lt Dominant Golfer</option>
                                                    </select>
                                            </FormGroup>  
                                        </div>    
                                        <div className="col-sm-12 col-md-6 col-xl-12">
                                            <FormGroup>
                                                <Label for="Select">Chief Complaint</Label>
                                                <textarea rows="4" type="text" name="chief_complaint" defaultValue={injurychartresponse.sic_chief_complaint} id="chief_complaint" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                            </FormGroup>
                                            <FormGroup>
                                                <Label for="Select">Mechanism Of Injury</Label>
                                                <textarea rows="4" type="text" name="mechanism_injury" id="mechanism_injury" defaultValue={injurychartresponse.sic_mechanism_injury} className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                            </FormGroup>                                                 
                                            <FormGroup>
                                                <Label for="Select">History of Present Injury</Label>
                                                <textarea rows="4" type="text" name="history_present_injury" id="history_present_injury" defaultValue={injurychartresponse.sic_history_present_injury} className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                            </FormGroup> 
                                            <FormGroup>
                                                <Label for="Select">History of Similar Injury in the Past</Label>
                                                <textarea rows="4" type="text" name="history_injury_past" id="history_injury_past" defaultValue={injurychartresponse.sic_history_injury_past}  className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                            </FormGroup> 
                                            <FormGroup>
                                                <Label for="Select">Clinical Observations and Assessment</Label>
                                                <textarea rows="4" type="text" name="observations_assessment" id="observations_assessment" defaultValue={injurychartresponse.sic_observations_assessment} className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                            </FormGroup> 
                                            <FormGroup>
                                                <Label for="Select">Clinical Findings</Label>
                                                <textarea rows="4" type="text" name="clinical_findings" id="clinical_findings" defaultValue={injurychartresponse.sic_clinical_findings} className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                            </FormGroup> 
                                            <FormGroup>
                                                <Label for="Select">Provisional Diagnosis</Label>
                                                <textarea rows="4" type="text" name="provisional_diagnosis" id="provisional_diagnosis" defaultValue={injurychartresponse.sic_provisional_diagnosis} className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                            </FormGroup> 
                                            <FormGroup>
                                                <Label for="Select">Injury Severity</Label>
                                                <textarea rows="4" type="text" name="injury_severity" id="injury_severity" defaultValue={injurychartresponse.sic_injury_severity} className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                            </FormGroup> 
                                            <FormGroup>
                                                <Label for="Select">Further Consultation and Investigations (if any)</Label>
                                                <textarea rows="4" type="text" name="consultation_investigations" id="consultation_investigations" defaultValue={injurychartresponse.sic_consultation_investigations} className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                            </FormGroup> 
                                            <FormGroup>
                                                <Label for="Select">Plan of Action</Label>
                                                <textarea rows="4" type="text" name="plan_action" id="plan_action" defaultValue={injurychartresponse.sic_plan_action} className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                            </FormGroup> 
                                            <FormGroup>
                                                <Label for="Select">Restrictions (if any)</Label>
                                                <textarea rows="4" type="text" name="restrictions" id="restrictions" defaultValue={injurychartresponse.sic_restrictions} className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                            </FormGroup> 
                                            <FormGroup>
                                                <Label for="Select">Expected time for Return to Sports</Label>
                                                <textarea rows="4" type="text" name="return_sports" id="return_sports" defaultValue={injurychartresponse.sic_return_sports} className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                            </FormGroup> 
                                            <FormGroup>
                                                <Label for="Select">Update for the S&C team</Label>
                                                <textarea rows="4" type="text" name="sc_team" id="sc_team" defaultValue={injurychartresponse.sic_sc_team} className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                            </FormGroup> 
                                            <FormGroup>
                                                <Label for="Select">Update for the Coaching team</Label>
                                                <textarea rows="4" type="text" name="coaching_team" id="coaching_team" defaultValue={injurychartresponse.sic_coaching_team} className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                            </FormGroup> 
                                        </div>
                                        <div className="form-group">
                                            <input type="hidden" name="eid" id="eid" value={injurychartresponse.sicID}></input>
                                            <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Update" />
                                            <input type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.props.onClick} value="Back" />
                                        </div>                                           
                                    </div>
                            </RctCollapsibleCard>  
                            </div> 
                            
                        </div>    
                     </form> 
                  </div>
         </div>
      );
   }
}


const mapStateToProps = ({ injurychart, ssteam }) => {
    const { injurychartresponse, loading } = injurychart;
    const { ssteamlists } = ssteam;
    return { injurychartresponse, ssteamlists, loading };
}

export default connect(mapStateToProps, {
    allSSTeam,
    fetchInjuryChart,
    editInjuryChart,
    
})(EditElements); 